export default "__VITE_ASSET__Dl6qbqiq__"